import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function RequireStaff({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <div className="p-10 text-center">Your role ({user.role}) doesn't have access to this page.</div>;
  }
  return children;
}

export function RequireCustomer({ children }) {
  const { customer, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-muted-foreground">Loading…</div>;
  if (!customer) return <Navigate to="/login?as=customer" replace />;
  return children;
}
